// NonFerrousMetalsPage.js
import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// Removed import of PageLayout as it is no longer used

const NonFerrousMetalsPage = () => {
  // Define breadcrumbs directly within the component
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Metals & Materials', path: '/metals-materials' },
    { name: 'Non-Ferrous Metals', path: '/metals-materials/non-ferrous' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 2 }}>
      <Container sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: { xs: 2, md: 4 }, px: { xs: 2, md: 0 } }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              crumb.path ? (
                <MuiLink component={RouterLink} to={crumb.path} key={index} underline="hover" color="text.secondary" variant="body2">
                  {crumb.name}
                </MuiLink>
              ) : (
                <Typography key={index} color="text.primary" variant="body2">{crumb.name}</Typography>
              )
            ))}
          </Breadcrumbs>
        </Box>

        <Typography variant="h3" align="center" fontWeight={700} sx={{ mb: { xs: 4, md: 6 }, color: 'text.primary' }}>
          Non-Ferrous Metals
        </Typography>

        <Typography variant="body1" paragraph>
          Non-ferrous metals do not contain iron in significant amounts and are valued for properties like corrosion resistance, low density, and good conductivity. Key examples include aluminum, copper, brass, lead, and zinc.
        </Typography>
        <Typography variant="body1" paragraph>
          These metals are crucial for a wide range of applications, from electrical wiring to aerospace components, making their recycling highly valuable.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          *Examples: Aluminum scrap, Copper wire, Brass fittings, Lead batteries, Zinc sheets.*
        </Typography>
      </Container>
    </Box>
  );
};

export default NonFerrousMetalsPage;
